'use client';
import * as React from 'react';
import * as RSwitch from '@radix-ui/react-switch';
import { cn } from '../cn';

export interface SwitchProps extends React.ComponentPropsWithoutRef<typeof RSwitch.Root> {
  size?: 'sm' | 'md';
}
export const Switch = React.forwardRef<React.ElementRef<typeof RSwitch.Root>, SwitchProps>(function Switch({ className, size = 'md', ...props }, ref) {
  const dims = size === 'sm' ? 'h-5 w-8' : 'h-[26px] w-[44px]';
  const thumb = size === 'sm' ? 'size-4 data-[state=checked]:translate-x-3' : 'size-[22px] data-[state=checked]:translate-x-[18px]';
  return (
    <RSwitch.Root ref={ref} className={cn('relative inline-flex shrink-0 cursor-pointer items-center rounded-full bg-fill transition-colors duration-200 data-[state=checked]:bg-green disabled:opacity-50 outline-none focus-visible:shadow-[0_0_0_3px_var(--accent-ring)]', dims, className)} {...props}>
      <RSwitch.Thumb className={cn('block translate-x-0.5 rounded-full bg-white shadow-[0_2px_4px_rgba(0,0,0,0.2),0_0_0_0.5px_rgba(0,0,0,0.06)] transition-transform duration-200 ease-[var(--ease-spring)]', thumb)} />
    </RSwitch.Root>
  );
});
